<div>
  <app-mat-spinner-overlay *ngIf="showSpinner"> </app-mat-spinner-overlay>
  <form
    #fdf="ngForm"
    (ngSubmit)="OnSaveBranchEmployeeProcessModel()"
    novalidate
  >
    <div class="row m-0 col-md-12 p-0 formborder">
      <div class="col-md-4 p-1">
        <span>Employee Name </span>
        <input required type="text" #refProductName="ngModel" name="EmployeeName" id="EmployeeName" placeholder="Employee Name"
               [(ngModel)]="EmployeeName" class="form-control input-text-css" disabled>
      </div>
      <div class="col-md-4 p-1">
        <span> Designation </span>
        <select name="SelectRoleId" id="SelectRoleId" disabled [(ngModel)]="SelectRoleId" class="form-control input-text-css">

          <option *ngFor="let rolesDropdownData of RolesDropdownData" [value]="rolesDropdownData.RoleId">
            {{rolesDropdownData.Role_Name}}
          </option>
        </select>
      </div>
      <div class="col-md-4 p-1">
        <span>Reporting Manager </span>
        <select name="EmpManagerId" id="EmpManagerId" disabled [(ngModel)]="EmpManagerId" class="form-control input-text-css">

          <option *ngFor="let reportingManager of ReportingManagerDropdown" [value]="reportingManager.EmpId">
            {{reportingManager.EmpName}}
          </option>
        </select>
      </div>
      <div class="col-md-3">
          <div class="d-flex align-items-center" style="gap: 0.75rem; height: 2.125rem; margin-bottom: 0.75rem;">
            <button
          type="button"
          (click)="AddBranchEmployeeProcess()"
          class="mt-3 btn font-size-12 button-btn"
        >
          <i class="fas fa-plus"></i> Add
        </button>
          </div>
        </div>
    </div>
  </form>

  <!-- <div
    class="formborder mt-3"
    style="
      width: 100%;
      display: flex;
      justify-content: space-around;
      align-items: center;
      gap: 0.5rem;
      overflow-x: scroll;
    "
    *ngIf="showResults"
  >
    <div class="cards-container" style="display: flex; gap: 0.5rem">
      <div *ngFor="let card of cardsData; let i = index" class="card" style="width: 21.9375rem">
        <div
          class="card-header"
          style="
            display: flex;
            background-color: #0e5c81;
            color: white;
            justify-content: space-between;
            align-items: center;
            border-radius: 0.4375rem;
          "
        >
          <span>Voucher Authorization Slab</span>

          <span
            ><i
              style="color: #fff !important; cursor: pointer; font-size: 1.125rem"
              class="fas fa-lg fa-edit margin-right-2xs"
              aria-label="true"
              (click)="EditBranchEmployeeProcess(card.Id,card)"
            ></i
          ></span>

          <span>
            <i
              class="fa fa-trash style-delete"
              style="cursor: pointer; font-size: 1.125rem"
              *ngIf="i==cardsData.length-1"
                 (click)="DeleteBranchEmployeeProcess(card.Id)"
              aria-label="true"
            ></i>
          </span>
        </div>
        <div
          style="
            display: flex;
            justify-content: space-between;
            align-items: center;
          "
        >
          <div class="info">
            <span>From Amount:</span> {{ card.fromAmount }}
          </div>
          <div class="info"><span>To Amount:</span> {{ card.toAmount }}</div>
        </div>

        <div class="info">
          <table>
            <tr>
              <th>Voucher Type</th>
              <th>Employee Name</th>
            </tr>

            <tr
              *ngFor="let processAndEmployee of card.processAndEmployee"
              style="border: 1px solid black"
            >
              <td>{{ processAndEmployee.VoucherType }}</td>
              <td>{{ processAndEmployee.employeeName }}</td>
            </tr>
          </table>
        </div>
      </div>
    </div>
  </div>
</div>

<div
  class="modal fade in"
  id="BranchEmployeeProcessModel"
  tabindex="-1"
  role="dialog"
  aria-labelledby="myModalLabel"
  data-backdrop="false"
  style="background-color: rgba(0, 0, 0, 0.5); overflow: auto"
>
  <form #ff="ngForm" novalidate>
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header" style="padding: 0.625rem">
          <h6 class="modal-title" id="myModalLabel" name="myModalLabel">
            {{ isEditMode ? "Edit" : "Add" }} Voucher Authorization Slab
          </h6>
          <button
            type="button"
            (click)="OnCloseBranchEmployeeProcess()"
            class="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">
              <i class="far text-black fa-times-circle"></i>
            </span>
          </button>
        </div>
        <div class="modal-body formborder m-3">
          <div
            class="row m-0 font-size-12 align-items-center d-flex flex-column"
          >
            <div class="col-md-12">
              <span class="required-lable">From Amount</span>

              <input
                required
                type="number"
                #refFromAmount="ngModel"
                [ngClass]="{
                  'is-invalid': ff.submitted && refFromAmount.invalid,
                  'alert-warning':
                    refFromAmount.invalid &&
                    (refFromAmount.dirty ||
                      refFromAmount.touched ||
                      refFromAmount.untouched)
                }"
                [(ngModel)]="FromAmount"
                placeholder="From Amount"
                disabled
                name="FromAmount"
                id="FromAmount"
                class="form-control input-text-css"
              />
            </div>
            <div class="col-md-12">
              <span class="required-lable">To Amount</span>

              <input
                required
                type="number"
                [disabled]="isEditMode"
                #refToAmount="ngModel"
                [ngClass]="{
                  'is-invalid': ff.submitted && refToAmount.invalid,
                  'alert-warning':
                    refToAmount.invalid &&
                    (refToAmount.dirty ||
                      refToAmount.touched ||
                      refToAmount.untouched)
                }"
                [(ngModel)]="ToAmount"
                placeholder="To Amount"
                name="ToAmount"
                id="ToAmount"
                class="form-control input-text-css"
              />
              <div
                *ngIf="
                  FromAmount !== undefined &&
                  ToAmount !== undefined &&
                  ToAmount !== null &&
                  !validateAmounts()
                "
                class="alert alert-danger mt-1"
              >
                To Amount must be greater than From Amount.
              </div>
            </div>
            <div class="table-responsive mt-2" [hidden]="!dataSource">
              <table mat-table [dataSource]="dataSource">
                <ng-container matColumnDef="VoucherType">
                  <th mat-header-cell *matHeaderCellDef>Voucher Type</th>
                  <td mat-cell *matCellDef="let element">
                    {{ element.VoucherType }}
                  </td>
                </ng-container>

                <ng-container matColumnDef="Employee">
                  <th mat-header-cell *matHeaderCellDef>Employee</th>
                  <td mat-cell *matCellDef="let element; let i = index">
                    <mat-form-field>
                      <mat-select
                        name="SelectionEmps{{ i }}"
                        id="SelectionEmps{{ i }}"
                          [(ngModel)]="element.selectedOptions"
                        multiple
                        (selectionChange)="
                          onSelectionChange($event.value, element)
                        "
                      >
                        <mat-option
                          *ngFor="let option of element.EmployeeProcessList"
                          [value]="option.EmpIdIdentity"
                          >{{ option.Emp_Name }}</mat-option
                        >
                      </mat-select>
                    </mat-form-field>
                  </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr
                  mat-row
                  *matRowDef="let row; columns: displayedColumns"
                ></tr>
              </table>
            </div>
          </div>
        </div>
        <div class="modal-footer" style="border: none">
          <button
            type="button"
            (click)="OnSaveBranchEmployeeProcessModel()"
            class="mt-3 btn font-size-12 button-btn"
            [disabled]="!ff.form.valid || !validateAmounts() || !ToAmount"
          >
            Save
          </button>
        </div>
      </div>
    </div>
  </form>
</div> -->
<div
    class="formborder mt-3"
    style="
      width: 100%;
      display: flex;
      flex-direction: column;
      gap: 8px;
      overflow-x: auto;
    "
    *ngIf="showResults"
  >
    <div class="table-responsive">
      <table class="table">
        <thead>
          <tr>
            <th>From Amount</th>
            <th>To Amount</th>
            <th>Voucher Type</th>
            <th>Voucher Sub Type</th>
            <!-- <th>Employee</th> -->
            <th style="width: 80px">Action</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of employeeSlabList; let i = index">
            <td>{{ item.From_LoanAmount }}</td>
            <td>{{ item.To_LoanAmount }}</td>
            <td>{{ item.VoucherType }}</td>
            <td>{{ item.VoucherSubType }}</td>
            <!-- <td>{{ item.EmployeeName }}</td> -->
            <td>
              <i
                style="color: #0c0c0c; cursor: pointer; font-size: 16px"
                class="fas fa-lg fa-edit margin-right-2xs"
                aria-label="true"
                (click)="EditBranchEmployeeProcess(item.Id, item)"
              ></i>
              <i
                class="fa fa-trash style-delete ml-2"
                style="cursor: pointer; font-size: 16px"
               
                (click)="DeleteBranchEmployeeProcess(item.Id)"
                aria-label="true"
              ></i>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>

<div
  class="modal fade in"
  id="BranchEmployeeProcessModel"
  tabindex="-1"
  role="dialog"
  aria-labelledby="myModalLabel"
  data-backdrop="false"
  style="background-color: rgba(0, 0, 0, 0.5); overflow: auto"
>
  <form #ff="ngForm" novalidate>
    <div class="modal-dialog modal-lg" role="document">
      <div class="modal-content">
        <div class="modal-header" style="padding: 10px">
          <h6 class="modal-title" id="myModalLabel" name="myModalLabel">
            {{ isEditMode ? "Edit" : "Add" }} Voucher Authorization Slab
          </h6>
          <button
            type="button"
            (click)="OnCloseBranchEmployeeProcess()"
            class="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">
              <i class="far text-black fa-times-circle"></i>
            </span>
          </button>
        </div>
        <div class="modal-body formborder m-3">
          <div class="row m-0 font-size-12 align-items-center">
            <div class="col-md-3">
              <span class="required-lable">From Amount</span>
              <input
                required
                type="number"
                #refFromAmount="ngModel"
                [ngClass]="{
                  'is-invalid': ff.submitted && refFromAmount.invalid,
                  'alert-warning':
                    refFromAmount.invalid &&
                    (refFromAmount.dirty ||
                      refFromAmount.touched ||
                      refFromAmount.untouched)
                }"
                [(ngModel)]="FromAmount"
                placeholder="From Amount"
                
                name="FromAmount"
                id="FromAmount"
                class="form-control input-text-css"
              />
            </div>
            <div class="col-md-3">
               
              <span class="required-lable">To Amount</span>
              <input
                required
                type="number"
               
                #refToAmount="ngModel"
                [ngClass]="{
                  'is-invalid': ff.submitted && refToAmount.invalid,
                  'alert-warning':
                    refToAmount.invalid &&
                    (refToAmount.dirty ||
                      refToAmount.touched ||
                      refToAmount.untouched)
                }"
                [(ngModel)]="ToAmount"
                placeholder="To Amount"
                name="ToAmount"
                id="ToAmount"
                class="form-control input-text-css"
              />
             
            </div>

            <div class="col-md-3 mt-2">
              <span class="required-lable">Voucher Type</span>
              <select
                required
                #refVoucherType="ngModel"
                [disabled]="isEditMode"
                [ngClass]="{
                  'is-invalid': ff.submitted && refVoucherType.invalid,
                  'alert-warning':
                    refVoucherType.invalid &&
                    (refVoucherType.dirty ||
                      refVoucherType.touched ||
                      refVoucherType.untouched)
                }"
                [(ngModel)]="VoucherType_Id"
                name="VoucherType_Id"
                id="VoucherType_Id"
                class="form-control input-text-css"
                (change)="getVoucherSubTypeList()"
              >
                <option value="">Select Voucher Type</option>
                <!-- <option *ngFor="let v of VoucherTypeList" [value]="v.Id">
                  {{ v.Value }}
                </option> -->
                <option *ngFor="let v of availableVoucherTypeList" [value]="v.Id">
    {{ v.Value }}
  </option>
              </select>
            </div>

            <!-- <div class="col-md-3 mt-2">
              <span class="required-lable">Voucher Sub Type</span>
              <select
                required
                #refVoucherSubType="ngModel"
                [ngClass]="{
                  'is-invalid': ff.submitted && refVoucherSubType.invalid,
                  'alert-warning':
                    refVoucherSubType.invalid &&
                    (refVoucherSubType.dirty ||
                      refVoucherSubType.touched ||
                      refVoucherSubType.untouched)
                }"
                [(ngModel)]="Voucher_SubType_id"
                name="Voucher_SubType_id"
                id="Voucher_SubType_id"
                class="form-control input-text-css"
              >
                <option value="">Select Voucher Sub Type</option>
                <option *ngFor="let s of VoucherSubTypeList" [value]="s.Id">
                  {{ s.Value }}
                </option>
                <option value="1">Loan</option>
                <option value="2">Accounting</option>
                <option value="3">Partner</option>
              </select>
            </div> -->
            <div class="col-md-3">
      <span>Voucher Sub Type</span>
      <ng-multiselect-dropdown
      required
        class="vouchersubtype-multiselect"
        name="Voucher_SubType_id"
        id="Voucher_SubType_id"
        #refVoucherSubType="ngModel"
        [(ngModel)]="Voucher_SubType_id"
        [placeholder]="'Select Sub Type'"
        [ngClass]="{
                  'is-invalid': ff.submitted && refVoucherSubType.invalid,
                  'alert-warning':
                    refVoucherSubType.invalid &&
                    (refVoucherSubType.dirty ||
                      refVoucherSubType.touched ||
                      refVoucherSubType.untouched)
                }"
        [data]="VoucherSubTypeList"
        [settings]="voucherSubTypeDropdownSettings"
        (onDropDownClose)="onVoucherSubTypeSelectionChange()"
      >
      </ng-multiselect-dropdown>
      <i class="fa-solid fa-angle-down dropdown-icon"></i>
    </div>

            <!-- <div class="col-md-12 mt-2">
              <span class="required-lable">Employee</span>
              <select
                required
                #refEmpId="ngModel"
                [ngClass]="{
                  'is-invalid': ff.submitted && refEmpId.invalid,
                  'alert-warning':
                    refEmpId.invalid &&
                    (refEmpId.dirty ||
                      refEmpId.touched ||
                      refEmpId.untouched)
                }"
                [(ngModel)]="EmpId"
                name="EmpId"
                id="EmpId"
                class="form-control input-text-css"
              >
                <option value="">Select Employee</option>
                <option
                  *ngFor="let e of EmployeeList"
                  [value]="e.EmpIdIdentity"
                >
                  {{ e.Emp_Name }}
                </option>
              </select>
            </div> -->
          </div>
        </div>
        <div class="modal-footer" style="border: none">
          <div
                *ngIf="
                  FromAmount !== undefined &&
                  ToAmount !== undefined &&
                  ToAmount !== null &&
                  !validateAmounts()
                "
                class="alert alert-danger mt-1"
              >
                To Amount must be greater than From Amount.
              </div>
              <div>
          <button
            type="button"
            (click)="OnSaveBranchEmployeeProcessModel()"
            class="mt-3 btn font-size-12 button-btn"
            [disabled]="!ff.form.valid || !validateAmounts() || !ToAmount"
          >
            Save
          </button>
          </div>
        </div>
      </div>
    </div>
  </form>
</div>